export const commonIt: Record<string, string> = {
  // Common
  'common.error': 'Errore',
  'common.add': 'Aggiungi',
  'common.notes': 'Note',
  'common.success': 'Successo',
  'common.loading': 'Caricamento',
  'common.cancel': 'Annulla',
  'common.close': 'Chiudi',
  'common.retry': 'Riprova',
  'common.tryAgain': 'Riprova',
  'common.reloadPage': 'Ricarica Pagina',
  'common.alternative': 'Alternativa',
  'common.somethingWentWrong': 'Qualcosa è andato storto',
  'common.errorDetails': 'Dettagli errore',
  'common.new': 'Nuovo',
  'common.viewDetails': 'Visualizza Dettagli',
  'common.comingSoon': 'Prossimamente',
  'common.printing': 'Stampa...',
  'common.today': 'Oggi',
  'common.all': 'Tutti',
  'common.appointments': 'appuntamenti',
  'common.appointment': 'appuntamento',
  'common.severity.error': 'Errore',
  'common.severity.warning': 'Avviso',
  'common.severity.info': 'Info',
  'common.review': 'Rivedi',
  'common.hide': 'Nascondi',
  'common.print': 'Stampa',
  'auth.required': 'Autenticazione richiesta',
  'auth.loginRequired': 'Accedi per continuare',
  'auth.page.loading': 'Caricamento...',
  'auth.page.heroAlt': 'Bellissimo momento di cerimonia nuziale',
  'auth.page.heroSubtitle': 'Gestione avanzata per boutique bridal',
  'auth.page.mobileSubtitle': 'CRM Bridal',
  'auth.page.welcomeTitle': 'Benvenuto in Sposa Suite',
  'auth.page.signInDescription': 'Accedi al tuo account per iniziare',
  'auth.page.emailLabel': 'Email',
  'auth.page.emailPlaceholder': 'Inserisci la tua email',
  'auth.page.passwordLabel': 'Password',
  'auth.page.passwordPlaceholder': 'Inserisci la tua password',
  'auth.page.signingIn': 'Accesso in corso...',
  'auth.page.signIn': 'Accedi',
  'auth.page.signUpDisabled': "La registrazione è attualmente disabilitata. Contatta l'amministratore per ottenere l'accesso.",
  'comingSoon.backToDashboard': 'Torna alla Dashboard',
  'comingSoon.back': 'Indietro',
  'comingSoon.badge': 'In arrivo {timeline}',
  'comingSoon.featuresAheadTitle': 'Nuove funzionalità in arrivo',
  'comingSoon.featuresAheadDescription': 'Stiamo lavorando per offrirti queste funzionalità avanzate',
  'comingSoon.notifyTitle': 'Ricevi notifica',
  'comingSoon.notifyDescription': 'Sii il primo a sapere quando questa funzionalità sarà disponibile',
  'comingSoon.notifyButton': 'Avvisami quando è pronta',
  'comingSoon.notifyFooter': 'Ti invieremo una email quando questa funzionalità verrà rilasciata',
  'comingSoon.roadmapTitle': 'Roadmap Sposa Suite:',
  'comingSoon.roadmapBody': "Stiamo migliorando continuamente la tua esperienza di gestione boutique bridal. Hai suggerimenti o esigenze specifiche? Contatta il nostro team e condividi il tuo feedback.",
  'invitation.invalidTitle': 'Invito non valido o scaduto',
  'invitation.invalidDescription': 'Questo link di invito non è valido oppure è scaduto.',
  'invitation.unknownRole': 'Ruolo sconosciuto',
  'invitation.unknownOrganization': 'Organizzazione sconosciuta',
  'invitation.loadError': "Impossibile caricare i dettagli dell'invito.",
  'invitation.passwordMismatchTitle': 'Password non corrispondenti',
  'invitation.passwordMismatchDescription': 'Le password non corrispondono.',
  'invitation.passwordTooShortTitle': 'Password troppo corta',
  'invitation.passwordTooShortDescription': 'La password deve contenere almeno 6 caratteri.',
  'invitation.acceptErrorTitle': "Impossibile accettare l'invito",
  'invitation.acceptErrorDescription': "Si è verificato un errore durante l'accettazione dell'invito.",
  'invitation.accountCreatedTitle': 'Account creato con successo',
  'invitation.accountCreatedDescription': 'Accedi con le nuove credenziali.',
  'invitation.acceptSuccessDescription': "Benvenuto! Il tuo account è stato creato e ora hai effettuato l'accesso.",
  'invitation.acceptRetryError': "Impossibile accettare l'invito. Riprova.",
  'invitation.invalidCardTitle': 'Invito non valido',
  'invitation.goHome': 'Vai alla Home',
  'invitation.acceptTitle': 'Accetta invito',
  'invitation.invitedAs': 'Sei stato invitato a unirti a {organization} come {role}.',
  'invitation.password': 'Password',
  'invitation.confirmPassword': 'Conferma password',
  'invitation.creatingAccount': 'Creazione account...',
  'invitation.acceptAndCreate': 'Accetta invito e crea account',
  'admin.waitlist.fetchError': "Impossibile caricare i dati della waitlist",
  'admin.waitlist.exportSuccess': 'Waitlist esportata con successo',
  'admin.waitlist.exportError': 'Impossibile esportare la waitlist',
  'admin.waitlist.title': 'Gestione Waitlist',
  'admin.waitlist.subtitle': 'Iscrizioni early access e generazione lead',
  'admin.waitlist.exporting': 'Esportazione...',
  'admin.waitlist.exportCsv': 'Esporta CSV',
  'admin.waitlist.searchPlaceholder': 'Cerca per email, boutique o paese...',
  'admin.waitlist.filterByCountry': 'Filtra per paese',
  'admin.waitlist.allCountries': 'Tutti i Paesi',
  'admin.waitlist.filterByPainPoint': 'Filtra per problema',
  'admin.waitlist.allPainPoints': 'Tutti i Problemi',
  'admin.waitlist.showingEntries': 'Mostrando {filtered} di {total} voci',
  'admin.waitlist.matching': 'corrispondenti a "{term}"',
  'admin.waitlist.stats.totalSignups': 'Iscrizioni Totali',
  'admin.waitlist.stats.lastMonthGrowth': '+12% rispetto al mese scorso',
  'admin.waitlist.stats.countries': 'Paesi',
  'admin.waitlist.stats.globalReach': 'Copertura globale in crescita',
  'admin.waitlist.stats.thisWeek': 'Questa Settimana',
  'admin.waitlist.stats.newSignups': 'Nuove iscrizioni questa settimana',
  'admin.waitlist.entriesTitle': 'Voci Waitlist',
  'admin.waitlist.entriesDescription': '{filtered} di {total} titolari boutique in attesa di accesso anticipato',
  'admin.waitlist.empty.noEntries': 'Nessuna voce in waitlist',
  'admin.waitlist.empty.noMatch': 'Nessuna voce corrisponde ai filtri',
  'admin.waitlist.empty.noEntriesDescription': "Le iscrizioni alla waitlist appariranno qui quando gli utenti si uniranno al programma early access.",
  'admin.waitlist.empty.noMatchDescription': 'Prova a modificare i termini di ricerca o i filtri per vedere più risultati.',
  'admin.waitlist.table.boutiqueName': 'Nome Boutique',
  'admin.waitlist.table.country': 'Paese',
  'admin.waitlist.table.painPoint': 'Problema',
  'admin.waitlist.table.joinedDate': 'Data Iscrizione',
  'admin.dashboard.title': 'Dashboard',
  'admin.dashboard.subtitle': 'Panoramica di tutte le organizzazioni e metriche di sistema',
  'admin.dashboard.stats.totalOrganizations': 'Organizzazioni Totali',
  'admin.dashboard.stats.totalOrganizationsDescription': 'Organizzazioni attive nel sistema',
  'admin.dashboard.stats.activeUsers': 'Utenti Attivi',
  'admin.dashboard.stats.activeUsersDescription': 'Totale utenti attivi in tutte le organizzazioni',
  'admin.dashboard.stats.totalLeads': 'Lead Totali',
  'admin.dashboard.stats.totalLeadsDescription': 'Lead generati in tutte le organizzazioni',
  'admin.dashboard.stats.waitlistSignups': 'Iscrizioni Waitlist',
  'admin.dashboard.stats.waitlistSignupsDescription': 'Membri waitlist accesso anticipato',
  'admin.dashboard.recentActivity.title': 'Attività Recenti',
  'admin.dashboard.recentActivity.description': 'Ultime attività e modifiche di sistema',
  'admin.dashboard.recentActivity.empty': 'Nessuna attività recente',
  'admin.dashboard.geographic.title': 'Distribuzione Geografica',
  'admin.dashboard.geographic.description': 'Iscrizioni waitlist per paese',
  'admin.dashboard.geographic.empty': 'Nessun dato geografico disponibile',
  'admin.dashboard.performance.title': 'Prestazioni Sistema',
  'admin.dashboard.performance.description': 'Metriche di sistema in tempo reale',
  'admin.dashboard.performance.avgResponseTime': 'Tempo medio di risposta',
  'admin.dashboard.performance.activeConnections': 'Connessioni attive',
  'admin.dashboard.performance.errorRate': 'Tasso di errore',
  'admin.dashboard.performance.empty': 'Nessun dato prestazionale disponibile',
  'admin.dashboard.health.title': 'Salute Sistema',
  'admin.dashboard.health.description': 'Stato corrente del sistema e servizi',
  'admin.dashboard.health.healthy': 'Sano',
  'admin.dashboard.health.unhealthy': 'Non sano',
  'admin.dashboard.health.empty': 'Nessun dato salute disponibile',
  'admin.dashboard.growth.title': 'Trend di Crescita',
  'admin.dashboard.growth.description': 'Confronto crescita mensile',
  'admin.dashboard.growth.organizations': 'Organizzazioni',
  'admin.dashboard.growth.waitlist': 'Waitlist',
  'admin.organizations.fetchError': 'Impossibile caricare le organizzazioni: {message}',
  'admin.organizations.createSuccess': 'Organizzazione creata con successo',
  'admin.organizations.createError': "Impossibile creare l'organizzazione",
  'admin.organizations.updateSuccess': 'Organizzazione aggiornata con successo',
  'admin.organizations.updateError': "Impossibile aggiornare l'organizzazione",
  'admin.organizations.bulkUpdated': 'Aggiornate {count} organizzazioni',
  'admin.organizations.bulkUpdateError': 'Impossibile aggiornare le organizzazioni',
  'admin.organizations.title': 'Organizzazioni',
  'admin.organizations.subtitle': 'Gestisci tutte le organizzazioni nel sistema',
  'admin.organizations.createButton': 'Crea organizzazione',
  'admin.organizations.createDialogTitle': 'Crea nuova organizzazione',
  'admin.organizations.createDialogDescription': "Crea una nuova organizzazione con impostazioni predefinite",
  'admin.organizations.organizationName': 'Nome organizzazione',
  'admin.organizations.organizationNamePlaceholder': 'Inserisci nome organizzazione',
  'admin.organizations.domainOptional': 'Dominio (opzionale)',
  'admin.organizations.domainPlaceholder': 'example.com',
  'admin.organizations.creating': 'Creazione...',
  'admin.organizations.searchPlaceholder': 'Cerca organizzazioni per nome o dominio...',
  'admin.organizations.filterByStatus': 'Filtra per stato',
  'admin.organizations.allStatus': 'Tutti gli stati',
  'admin.organizations.inactive': 'Inattiva',
  'admin.organizations.suspended': 'Sospesa',
  'admin.organizations.bulkActions': 'Azioni di gruppo ({count})',
  'admin.organizations.activateSelected': 'Attiva selezionate',
  'admin.organizations.deactivateSelected': 'Disattiva selezionate',
  'admin.organizations.suspendSelected': 'Sospendi selezionate',
  'admin.organizations.showing': 'Mostrando {filtered} di {total} organizzazioni',
  'admin.organizations.matching': 'corrispondenti a "{term}"',
  'admin.organizations.allOrganizations': 'Tutte le organizzazioni',
  'admin.organizations.totalDescription': '{filtered} di {total} organizzazioni totali',
  'admin.organizations.table.domain': 'Dominio',
  'admin.organizations.table.status': 'Stato',
  'admin.organizations.table.plan': 'Piano',
  'admin.organizations.table.users': 'Utenti',
  'admin.organizations.table.actions': 'Azioni',
  'admin.organizations.table.activeUsers': '{count} attivi',
  'admin.organizations.table.leads': '{count} lead',
  'admin.organizations.editDialogTitle': 'Modifica organizzazione',
  'admin.organizations.editDialogDescription': 'Aggiorna dettagli e stato organizzazione',
  'admin.organizations.selectStatus': 'Seleziona stato',
  'admin.organizations.updating': 'Aggiornamento...',
  'admin.organizations.updateButton': 'Aggiorna organizzazione',
  'founders.title': 'Benvenuto nel Founding Boutique Circle!',
  'founders.subtitle': 'Hai ottenuto il tuo Founding Boutique Pass con pagamento una tantum di €3.000.',
  'founders.paymentConfirmed': 'Pagamento confermato',
  'founders.confirmationSentTo': 'Conferma inviata a:',
  'founders.whatsNext': 'Cosa succede ora',
  'founders.next.item1': 'Riceverai una email di benvenuto dettagliata entro 24 ore',
  'founders.next.item2': 'Accesso prioritario alla nostra community privata Founders',
  'founders.next.item3': 'Aggiornamenti prodotto in anteprima e preview esclusive',
  'founders.next.item4': 'Canale diretto di feedback con il nostro team fondatore',
  'founders.benefitsTitle': 'I tuoi benefici Founder',
  'founders.benefits.item1': 'Accesso a vita a tutte le funzionalità attuali e future di Sposa Suite',
  'founders.benefits.item2': 'Sconto a vita del 35% sull\'abbonamento, bloccato per sempre.',
  'founders.benefits.item3': 'Supporto onboarding prioritario, 6 mesi di guida 1-a-1 (valore €20.000)',
  'founders.benefits.item4': 'Co-creazione di nuove funzionalità con il team roadmap prodotto',
  'founders.benefits.item5': 'Invito a eventi esclusivi Founder-only e networking',
  'founders.helpText': 'Domande? Pronto a iniziare? Siamo qui per aiutarti.',
  'founders.returnHome': 'Torna alla Homepage',
  'founders.memberNumber': 'Membro Fondatore #{number}',
  'today': 'Oggi',
  'creating': 'Creazione...',
  'create_new_appointment': 'Crea nuovo appuntamento',
  'auto_save_message': 'I tuoi progressi vengono salvati automaticamente',
  'back_button': 'Indietro',
  'budget_label': 'Fascia di budget',
  'choose_files': 'Scegli file',
  'complete_button': 'Completa',
  'dress_size': 'Taglia abito',
  'drop_images_text': 'Trascina qui le immagini o fai clic per caricarle',
  'event_location': 'Luogo evento',
  'first_name': 'Nome',
  'image_upload_limit': 'Massimo 5 immagini, 5MB ciascuna',
  'images_uploaded': 'immagini caricate',
  'inspiration_images': 'Immagini di ispirazione',
  'last_name': 'Cognome',
  'maximum': 'Massimo',
  'minimum': 'Minimo',
  'name_label': 'Nome',
  'next_button': 'Avanti',
  'partner_label': 'Partner',
  'phone_label': 'Telefono',
  'profile_summary': 'Riepilogo profilo',
  'select_dress_size': 'Seleziona la tua taglia abito',
  'step1_title': 'Informazioni di contatto',
  'step2_title': 'Dettagli evento',
  'step3_title': 'Preferenze abito',
  'step4_title': 'Passaggio 4 di 4: Rivedi e completa',
  'success_message': 'Profilo completato! Controlla la tua email per un link di accesso sicuro.',
  'uploading': 'Caricamento...',
  'wedding_date_label': 'Data matrimonio',
  'welcome_back_message': 'Bentornata! Abbiamo ripristinato i tuoi progressi.',
  'filters.title': 'Filtri',
  'track_alteration_tasks': 'Monitora attività e avanzamento delle modifiche',
  'calendar.no_appointments': 'Nessun appuntamento',
  'jobCentre.title': 'Job Centre',
  'jobCentre.subtitle': 'Anteprima delle funzionalità di gestione attività',
  'jobCentre.permissions.noAccess': 'Non hai i permessi per visualizzare le attività.',
  'jobCentre.permissions.contactAdmin': "Contatta l'amministratore per richiedere l'accesso.",
  'jobCentre.actions.snoozeSelected': 'Posticipa selezionati',
  'jobCentre.actions.completeSelected': 'Completa selezionati',
  'jobCentre.tabs.all': 'Tutte le attività',
  'jobCentre.tabs.leads': 'Lead',
  'jobCentre.tabs.customers': 'Clienti',
  'jobCentre.loadingTasks': 'Caricamento attività...',
  'jobCentre.empty.all.title': 'Nessuna attività trovata',
  'jobCentre.empty.all.description': 'Non ci sono attività che corrispondono ai filtri correnti.',
  'jobCentre.empty.leads.title': 'Nessuna attività lead trovata',
  'jobCentre.empty.leads.description': 'Al momento non ci sono attività legate ai lead.',
  'jobCentre.empty.customers.title': 'Nessuna attività cliente trovata',
  'jobCentre.empty.customers.description': 'Al momento non ci sono attività legate ai clienti.',
  'jobCentre.groups.overdue': 'In ritardo',
  'jobCentre.groups.upcoming': 'In arrivo',
  'jobCentre.assignee.unassigned': 'Non assegnato',
  'jobCentre.assignee.placeholder': 'Assegna...',
  'jobCentre.entity.unknown': 'Sconosciuto',
  'jobCentre.entity.lead': 'Lead',
  'jobCentre.entity.customer': 'Cliente',
  'jobCentre.badge.demo': 'DEMO',
  'jobCentre.toast.demoTaskUpdated.title': 'Attività demo aggiornata',
  'jobCentre.toast.demoTaskUpdated.description': "Assegnatario cambiato in {assigneeName}. Questa è una demo: la funzionalità reale arriverà presto!",
  'jobCentre.toast.demoTask.title': 'Attività demo',
  'jobCentre.toast.demoTask.description': "Questa è un'attività demo. La gestione attività sarà disponibile quando sarai connesso ai tuoi dati.",
  'jobCentre.toast.demoTask.fullDetailsDescription': 'I dettagli completi dell\'attività saranno disponibili quando sarai connesso ai tuoi dati.',
  'jobCentre.toast.demoTasks.title': 'Attività demo',
  'jobCentre.toast.demoTasks.description': "Queste sono attività demo. La gestione attività sarà disponibile quando sarai connesso ai tuoi dati.",
  'jobCentre.toast.tasksCompleted': '{count} attività segnate come completate',
  'jobCentre.toast.completeError': 'Impossibile completare le attività. Riprova.',
  'jobCentre.toast.tasksSnoozed': '{count} attività posticipate a domani',
  'jobCentre.toast.snoozeError': 'Impossibile posticipare le attività. Riprova.',
  'jobCentre.toast.featureComingSoon.title': 'Funzionalità in arrivo',
  'jobCentre.toast.featureComingSoon.assigneeDescription': 'La modifica reale degli assegnatari sarà disponibile quando sarai connesso ai tuoi dati.',
  'jobCentre.demoTasks.followUp.title': 'Ricontatta il lead matrimonio',
  'jobCentre.demoTasks.followUp.description': 'Consulenza iniziale completata, inviare opzioni abiti e prezzi',
  'jobCentre.demoTasks.firstFitting.title': 'Pianifica la prima prova',
  'jobCentre.demoTasks.firstFitting.description': "La cliente ha scelto l'abito, fissare l'appuntamento di prova",
  'jobCentre.demoTasks.careInstructions.title': "Invia istruzioni per la cura dell'abito",
  'jobCentre.demoTasks.careInstructions.description': "Ritiro finale completato, inviare istruzioni di cura e conservazione",
  'jobCentre.demoTasks.depositPayment.title': 'Gestisci pagamento acconto',
  'jobCentre.demoTasks.depositPayment.description': "La cliente è pronta a ordinare, raccogliere l'acconto e creare il contratto",
  'jobCentre.demoTasks.finalAlterations.title': 'Modifiche finali abito',
  'jobCentre.demoTasks.finalAlterations.description': 'Completare le modifiche finali prima della data del matrimonio',
  'jobCentre.demoTasks.consultationCall.title': 'Chiamata di consulenza matrimonio',
  'jobCentre.demoTasks.consultationCall.description': 'Consulenza iniziale per discutere esigenze e mostrare la collezione abiti',
  'legal.lastUpdated.july2025': 'Luglio 2025',
  'legal.privacy.title': 'Sposa Suite - Informativa Privacy',
  'legal.privacy.section1.title': '1. Introduzione',
  'legal.privacy.section1.body': 'Sposa Suite ("noi", "ci", "nostro") è un sistema operativo completo per boutique che gestisce clienti, lead, comunicazioni, prodotti, ordini, finanze, fornitori, relazione con le spose, report e molto altro-in un unico posto. Questa informativa privacy spiega come Momentum Group s. r. o. ("Società") raccoglie, utilizza e protegge i tuoi dati quando usi Sposa Suite.',
  'legal.privacy.section2.title': '2. Dati che Raccogliamo',
  'legal.privacy.section2.companyAccount.label': 'Dati Account Aziendale:',
  'legal.privacy.section2.companyAccount.body': 'Nome atelier, ICO/VAT, indirizzo, email/telefono di contatto.',
  'legal.privacy.section2.userData.label': 'Dati Utente:',
  'legal.privacy.section2.userData.body': 'Nomi, email, numeri di telefono, ruoli e permessi.',
  'legal.privacy.section2.brideLead.label': 'Dati Sposa e Lead:',
  'legal.privacy.section2.brideLead.body': 'Contatti, date/location evento, foto misure, foto prove, elementi wishlist, cronologia appuntamenti, attività portale.',
  'legal.privacy.section2.operational.label': 'Dati Operativi:',
  'legal.privacy.section2.operational.body': 'Prodotti, livelli inventario, contatti fornitori, dettagli ordini, fatture, pagamenti.',
  'legal.privacy.section2.analytics.label': 'Uso e Analytics:',
  'legal.privacy.section2.analytics.body': 'Indirizzo IP, info dispositivo/browser, pagine e funzionalità usate, timestamp.',
  'legal.privacy.section2.communications.label': 'Comunicazioni e Supporto:',
  'legal.privacy.section2.communications.body': 'Messaggi e log chat tra agenti, consulenti e spose (via WhatsApp, Messenger, Instagram, SMS, email).',
  'legal.privacy.section2.payment.label': 'Dati di Pagamento:',
  'legal.privacy.section2.payment.body': 'ID transazione, registri fatture-i dati completi della carta sono gestiti da Stripe.',
  'legal.privacy.section3.title': '3. Come Usiamo i Tuoi Dati',
  'legal.privacy.section3.serviceOperation.label': 'Operatività del Servizio:',
  'legal.privacy.section3.serviceOperation.body': 'Supportare tutti i moduli-gestione lead, portale clienti, catalogo prodotti, ordini, fatturazione, monitoraggio fornitori, reportistica.',
  'legal.privacy.section3.communications.label': 'Comunicazioni:',
  'legal.privacy.section3.communications.body': 'Invio conferme, promemoria, messaggi di supporto e aggiornamenti portale.',
  'legal.privacy.section3.analytics.label': 'Analytics e Miglioramento:',
  'legal.privacy.section3.analytics.body': "Analizzare l'utilizzo per migliorare funzionalità, misurare le performance e formare il nostro team agenti 24/7.",
  'legal.privacy.section3.legalCompliance.label': 'Aspetti Legali e Compliance:',
  'legal.privacy.section3.legalCompliance.body': 'Prevenzione frodi, report fiscali, conformità GDPR/CCPA.',
  'legal.privacy.section4.title': '4. Cookie e Tracciamento',
  'legal.privacy.section4.body': 'Impostiamo cookie essenziali per autenticazione e cookie di performance (analytics/tracciamento errori). Puoi gestire il consenso tramite il banner cookie.',
  'legal.privacy.section5.title': '5. Condivisione Dati',
  'legal.privacy.section5.intro': 'Condividiamo informazioni solo con:',
  'legal.privacy.section5.providers.label': 'Fornitori di Servizi:',
  'legal.privacy.section5.providers.body': 'Stripe, Google Calendar, WhatsApp API, Meta Business-in base a rigorosi accordi di trattamento dati.',
  'legal.privacy.section5.staff.label': 'Staff Boutique:',
  'legal.privacy.section5.staff.body': "Utenti assegnati all'interno della tua organizzazione.",
  'legal.privacy.section5.authorities.label': 'Autorità Legali:',
  'legal.privacy.section5.authorities.body': 'Se richiesto dalla legge.',
  'legal.privacy.section6.title': '6. Pagamenti e Fatturazione',
  'legal.privacy.section6.body': 'Tutte le transazioni finanziarie passano tramite Stripe; non memorizziamo mai credenziali di pagamento complete. Puoi vedere fatture e cronologia pagamenti nel tuo Back-Office Hub.',
  'legal.privacy.section7.title': '7. Conservazione e Cancellazione Dati',
  'legal.privacy.section7.bodyPrefix': "Conserviamo i dati finché il tuo account è attivo o come richiesto dalla legge. Puoi richiedere esportazione o cancellazione dei tuoi dati contattando",
  'legal.privacy.section7.bodySuffix': '.',
  'legal.privacy.section8.title': '8. Sicurezza',
  'legal.privacy.section8.bodyPrefix': 'Usiamo cifratura TLS 1.3 in transito, AES 256-bit a riposo, accesso basato su ruoli e audit di sicurezza regolari. Segnala attività sospette a',
  'legal.privacy.section8.bodySuffix': '.',
  'legal.privacy.section9.title': '9. I Tuoi Diritti',
  'legal.privacy.section9.bodyPrefix': 'Ai sensi del GDPR e normative simili, hai diritto ad accedere, correggere, portare o cancellare i tuoi dati personali. Contatta',
  'legal.privacy.section9.bodySuffix': 'per esercitare questi diritti.',
  'legal.privacy.section10.title': '10. Modifiche a questa Informativa',
  'legal.privacy.section10.body': "Potremmo aggiornare questa informativa; le modifiche hanno effetto alla pubblicazione qui. L'uso continuato implica accettazione.",
  'legal.terms.title': 'Sposa Suite - Termini di Servizio',
  'legal.terms.section1.title': '1. Accordo',
  'legal.terms.section1.body': "Questi Termini regolano l'uso di Sposa Suite, il sistema all-in-one per boutique. Accedendo o utilizzando il Servizio, accetti questi Termini e la nostra Informativa Privacy.",
  'legal.terms.section2.title': '2. Account e Accesso',
  'legal.terms.section2.eligibility.label': 'Idoneità:',
  'legal.terms.section2.eligibility.body': 'Devi essere autorizzato dal tuo atelier ad agire per suo conto.',
  'legal.terms.section2.credentials.label': 'Credenziali:',
  'legal.terms.section2.credentials.body': "Mantieni sicure le credenziali di accesso. Sei responsabile di tutte le attività svolte con il tuo account.",
  'legal.terms.section2.roles.label': 'Ruoli e Permessi:',
  'legal.terms.section2.roles.body': 'Gli admin del salone configurano ruoli utente, livelli di accesso e visibilità menu in Impostazioni.',
  'legal.terms.section3.title': '3. Abbonamento e Costi',
  'legal.terms.section3.suitePlan.label': 'Piano Suite:',
  'legal.terms.section3.suitePlan.body': 'La tariffa fissa include Bridal Portal, Back-Office Hub e supporto base agenti 24/7.',
  'legal.terms.section3.seatsAddons.label': 'Postazioni e Add-on:',
  'legal.terms.section3.seatsAddons.body': 'Postazioni staff aggiuntive e servizi premium sono fatturati separatamente.',
  'legal.terms.section3.paymentTerms.label': 'Termini di Pagamento:',
  'legal.terms.section3.paymentTerms.body': 'Fatturazione ricorrente via Stripe. Disdetta con due mesi di preavviso; nessun rimborso per periodi parziali.',
  'legal.terms.section4.title': '4. Onboarding e Servizi Professionali',
  'legal.terms.section4.launchPackage.label': 'Pacchetto Launch:',
  'legal.terms.section4.launchPackage.body': 'Servizio opzionale di 8 settimane (EUR 20 000) per mappatura processi, configurazione, migrazione dati e formazione.',
  'legal.terms.section4.scopeChanges.label': 'Variazioni di Scope:',
  'legal.terms.section4.scopeChanges.body': 'Qualsiasi attività oltre le fasi definite è fatturata alla tariffa consulenziale standard.',
  'legal.terms.section5.title': '5. Uso Consentito',
  'legal.terms.section5.intro': 'Non puoi:',
  'legal.terms.section5.item1': 'Fare reverse-engineering, scraping o interrompere il Servizio.',
  'legal.terms.section5.item2': 'Usare Sposa Suite per attività illecite o inviare marketing non richiesto.',
  'legal.terms.section5.item3': "Distribuire malware o compromettere l'integrità del sistema.",
  'legal.terms.section6.title': '6. Proprietà Intellettuale',
  'legal.terms.section6.body': 'Tutto il software, i contenuti e i marchi appartengono a Momentum Group s. r. o. o ai rispettivi licenzianti. Ricevi una licenza limitata di utilizzo del Servizio secondo questi Termini.',
  'legal.terms.section7.title': '7. Riservatezza',
  'legal.terms.section7.body': 'Entrambe le parti proteggeranno le informazioni riservate reciproche e non le divulgheranno salvo obblighi di legge.',
  'legal.terms.section8.title': '8. Garanzie e Limitazioni',
  'legal.terms.section8.body': 'Puntiamo ad alta disponibilità ma forniamo il Servizio "così com\'è". Escludiamo tutte le garanzie implicite, incluse commerciabilità e idoneità a uno scopo specifico.',
  'legal.terms.section9.title': '9. Limitazione di Responsabilità',
  'legal.terms.section9.body': 'La nostra responsabilità è limitata al totale delle quote di abbonamento pagate nei 12 mesi precedenti. Non siamo responsabili per danni indiretti o consequenziali.',
  'legal.terms.section10.title': '10. Risoluzione',
  'legal.terms.section10.byYou.label': 'Da parte tua:',
  'legal.terms.section10.byYou.body': 'Puoi disdire con due mesi di preavviso; i dati saranno gestiti secondo la policy di conservazione.',
  'legal.terms.section10.byUs.label': 'Da parte nostra:',
  'legal.terms.section10.byUs.body': 'Possiamo sospendere o chiudere account per mancato pagamento, violazione dei Termini o uso illegale.',
  'legal.terms.section11.title': '11. Legge Applicabile',
  'legal.terms.section11.body': 'Questi Termini sono regolati dalla legge slovacca e le controversie sono risolte presso i tribunali di Bratislava.',
  'legal.terms.section12.title': '12. Modifiche ai Termini',
  'legal.terms.section12.body': "Ti notificheremo gli aggiornamenti 30 giorni prima della loro entrata in vigore. L'uso continuato implica accettazione.",

  // Error Boundaries
  'errorBoundary.productError': 'Si è verificato un errore durante il caricamento dei prodotti. Potrebbe essere un problema temporaneo.',
  'errorBoundary.generalError': 'Si è verificato un errore imprevisto. Prova ad aggiornare la pagina.',

  // Time units
  'day': 'giorno',
  'days': 'giorni',
  'hour': 'ora',
  'hours': 'ore',
  'minute': 'minuto',
  'minutes': 'minuti',
  'second': 'secondo',
  'seconds': 'secondi',
  'countdown_sr_days': 'giorni',
  'countdown_sr_hours': 'ore',
  'countdown_sr_minutes': 'minuti',
  'countdown_sr_seconds': 'secondi',
  'countdown_sr_until': 'fino al tuo matrimonio',

  // General labels
  'loading': 'Caricamento...',
  'coming_soon': 'Prossimamente',
  'soon': 'Presto',
  'success': 'Successo',
  'error': 'Errore',
  'cancel': 'Annulla',
  'edit': 'Modifica',
  'delete': 'Elimina',
  'new': 'Nuovo',
  'all': 'Tutti',
  'other': 'Altro',
  'category': 'Categoria',
  'size': 'Taglia',
  'color': 'Colore',
  'brand': 'Marca',
  'colour': 'Colore',
  'details': 'Dettagli',
  'history': 'Storico',
  'overview': 'Panoramica',
  'timeline': 'Timeline',
  'preview': 'Anteprima',
  'share': 'Condividi',
  'upload': 'Carica',
  'added': 'Aggiunto',
  'active': 'Attivi',
  'completed': 'Completati',
  'pending': 'In Attesa',
  'redeemed': 'Riscattato',
  'qty': 'Qtà',
  'total': 'Totale €',
  'more': 'altro',
  'view_details': 'Vedi Dettagli',
  'view_profile': 'Vedi profilo',
  'not_provided': 'Non fornito',

  // Document language selection
  'documents.selectLanguage': 'Seleziona lingua',
  'documents.languageHelp': 'Scegli la lingua per questo documento',

  // Database Field Labels
  'field_first_name': 'Nome',
  'field_last_name': 'Cognome',
  'field_email': 'Email',
  'field_phone': 'Telefono',
  'field_wedding_date': 'Data Matrimonio',
  'field_partner_name': 'Nome Partner',
  'field_order_no': 'Ordine #',
  'field_total_amount': 'Importo Totale',
  'field_balance': 'Saldo',
  'field_due_date': 'Data Scadenza',
  'field_delivery_date': 'Data Consegna',
  'field_task_name': 'Nome Attività',
  'field_task_type': 'Tipo Attività',
  'field_assignee': 'Assegnato a',
  'field_created_at': 'Creato',
  'field_updated_at': 'Aggiornato',
  'field_notes': 'Note',
  'field_title': 'Titolo',
  'field_organization_id': 'Organizzazione',
  'field_customer_id': 'Cliente',
  'field_user_id': 'Utente',
  'field_stage_id': 'Fase',
  'field_version': 'Versione',
  'field_measured_by': 'Misurato da',
  'field_photo_url': 'Foto',
  'field_contact_first_name': 'Nome',
  'field_contact_last_name': 'Cognome',
  'field_contact_email': 'Email',
  'field_contact_phone': 'Telefono',

  // Status Values
  'status_draft': 'Bozza',
  'status_open': 'Aperto',
  'status_confirmed': 'Confermato',
  'status_in_progress': 'In Corso',
  'status_completed': 'Completato',
  'status_cancelled': 'Annullato',
  'status_archived': 'Archiviato',
  'status_pending': 'In Attesa',
  'status_on_hold': 'In Pausa',
  'status_new': 'Nuovo',
  'status_contacted': 'Contattato',
  'status_qualified': 'Qualificato',
  'status_proposal_sent': 'Proposta Inviata',
  'status_won': 'Vinto',
  'status_lost': 'Perso',
  'status_redeemed': 'Riscattato',

  // Alteration Status
  'alteration_pending': 'In Attesa',
  'alteration_in_progress': 'In Corso',
  'alteration_completed': 'Completato',
  'alteration_on_hold': 'In Pausa',

  // Appointment Types
  'appointment_consultation': 'Consulenza',
  'appointment_fitting': 'Prova',
  'appointment_final_fitting': 'Prova Finale',
  'appointment_alteration': 'Modifica',

  // Conditional Displays
  'overdue_status': '(Scaduto)',
  'no_assignee': 'Non Assegnato',
  'no_data': '-',
  'select_assignee': 'Seleziona assegnatario',
  'no_stage_set': 'Nessuna fase impostata',
  'no_customer_set': 'Nessun cliente',
  'unknown_status': 'Sconosciuto',

  // Measurement Fields
  'field_bust': 'Seno',
  'field_waist': 'Vita',
  'field_hips': 'Fianchi',
  'field_height': 'Altezza',
  'field_shoulder': 'Spalla',
  'field_arm_circumference': 'Circonferenza Braccio',
  'field_bust_circumference': 'Circonferenza Seno',
  'field_waist_circumference': 'Circonferenza Vita',
  'field_hip_circumference': 'Circonferenza Fianchi',
  'field_chest_circumference': 'Circonferenza Torace',
  'field_abdomen_circumference': 'Circonferenza Addome',
  'field_wrist_circumference': 'Circonferenza Polso',
  'field_bust_height': 'Altezza Seno',
  'field_distance_between_breasts': 'Distanza tra i Seni',
  'field_shoulder_width_back': 'Larghezza Spalle Dietro',
  'field_waist_length_back': 'Lunghezza Vita Dietro',
  'field_waist_length_front': 'Lunghezza Vita Davanti',
  'field_sleeve_length': 'Lunghezza Manica',
  'field_skirt_length': 'Lunghezza Gonna',
  'field_hip_upper': 'Fianchi Superiori',

  // Payment Method Types
  'payment_cash': 'Contanti',
  'payment_card': 'Carta',
  'payment_bank_transfer': 'Bonifico Bancario',
  'payment_other': 'Altro',

  // Table Headers
  'table_name': 'Nome',
  'table_contact': 'Contatto',
  'table_partner': 'Partner',
  'table_portal_status': 'Stato Portale',
  'table_created': 'Creato',
  'table_customer_name': 'Nome Cliente',
  'table_order_number': 'Numero Ordine',
  'table_task_title': 'Attività',
  'table_priority': 'Priorità',
  'table_stage': 'Fase',
  'table_due_date': 'Data Scadenza',
  'table_type': 'Tipo',
  'table_measurement_version': 'Versione',
  'table_measurement_date': 'Data',
  'table_measured_by': 'Misurato da',

  // Communication Channels
  'channel_email': 'Email',
  'channel_phone': 'Telefono',
  'channel_sms': 'SMS',
  'channel_whatsapp': 'WhatsApp',
  'channel_instagram': 'Instagram',
  'channel_facebook': 'Facebook',

  // Shared source keys
  'sources.website': 'Sito web',
  'sources.instagram': 'Instagram',
  'sources.facebook': 'Facebook',
  'sources.referral': 'Referral',
  'sources.walkIn': 'Di persona',
  'sources.venue': 'Location',
  'sources.Form': 'Modulo',
  'sources.manual': 'Manuale',
  'sources.unknown': 'Sconosciuto',
  'sources.other': 'Altro',

  // Field names
  'fields.email': 'Email',
  'fields.firstName': 'Nome',
  'fields.lastName': 'Cognome',
  'fields.phone': 'Telefono',
  'fields.budgetMin': 'Budget Min',
  'fields.budgetMax': 'Budget Max',
  'fields.eventDate': 'Data Evento',
  'fields.eventLocation': 'Luogo Evento',
  'fields.partnerName': 'Nome Partner',
  'fields.source': 'Fonte',
  'fields.notes': 'Note',
  'fields.howDidYouHear': 'Come ci hai conosciuto',
  'fields.dreamWeddingDescription': 'Descrizione Matrimonio dei Sogni',
  'fields.specialRequests': 'Richieste Speciali',
  'fields.guestCount': 'Numero Ospiti',
  'fields.ceremony': 'Cerimonia',
  'fields.reception': 'Ricevimento',
  'fields.honeymoon': 'Luna di Miele',
  'fields.dressSize': 'Taglia Abito',
  'fields.dressStyle': 'Stile Abito',
  'fields.shoeSize': 'Numero Scarpe',
  'fields.hasChildren': 'Ha Figli',
  'fields.address': 'Indirizzo',
  'fields.city': 'Città',
  'fields.country': 'Paese',
  'fields.customField1': 'Campo Personalizzato 1',
  'fields.customField2': 'Campo Personalizzato 2',
  'fields.customField3': 'Campo Personalizzato 3',
  'fields.customField4': 'Campo Personalizzato 4',
  'fields.customField5': 'Campo Personalizzato 5',

  // Pagination
  'pagination.previous': 'Precedente',
  'pagination.next': 'Successivo',
  'pagination.goPrevious': 'Vai alla pagina precedente',
  'pagination.goNext': 'Vai alla pagina successiva',
  'pagination.morePages': 'Altre pagine',
  'pagination.showing': 'Mostrando {from}-{to} di {total}',

  // Validation
  'validation.mustBeFixed': 'deve essere corretto prima di salvare',
  'validation.canBeSavedWith': "L'appuntamento può essere salvato con",
  'validation.workBreak': 'Impossibile pianificare durante la pausa lavoro ({breakTime})',
  'validation.workBreakGeneric': 'Impossibile pianificare durante la pausa lavoro',
  'validation.warning': 'avviso',
  'validation.warnings': 'avvisi',
  'validation.field.title': 'Titolo',
  'validation.field.customer_id': 'Cliente',
  'validation.field.type': 'Tipo',
  'validation.field.start_time': 'Ora Inizio',
  'validation.field.end_time': 'Ora Fine',
  'validation.field.location': 'Posizione',
  'validation.field.description': 'Descrizione',
  'validation.field.staff_id': 'Staff',
  'validation.field.fitting_room_id': 'Sala Prova',

  // Shared action labels
  'common.save': 'Salva',
  'common.saving': 'Salvataggio...',
  'common.unsaved': 'Non salvato',

  // Access Denied
  'accessDenied.title': 'Accesso Negato',
  'accessDenied.description': 'Non hai il permesso di visualizzare questa pagina. Contatta il tuo amministratore per richiedere l\'accesso.',
  'accessDenied.goToDashboard': 'Vai alla Dashboard',
};
